<template>
  <div id="app">
    <router-view
      v-if="
        ( Object.keys(userinfo).length > 0
        && configLang
        )
        ||
        tokenFreePages.includes($route.path)
    "></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { userInfo, version, copyright} from '@/api.js'
import { 
  localPageKey,
  localPageSizeKey, 
  pdaScreenWidth, 
  departmentSterilityLibraryExpire,
  langs,
  apiLangKey,
  langKey,
  userTokenKey,
  lang,
  tokenFreePages
  } from '@/utils/Config.js'
export default {
  name: 'App',
  data() {
    return {
      userinfo: {},
      pdainfo: {},
      versionInfo: {},
      tokenFreePages,
      configLang: null
    }
  },
  async created() {
    this.checkPda()
    this.getCopyright()
    if (!tokenFreePages.includes(this.$route.path)) {
      this.getUserInfo()
      this.getDicts()
    }
    
    await this.getVersion()
    this.getConfigLang()
    this.checkBrowser()
    this.expirePop()
  },
  computed: {
    ...mapGetters(['exec', 'user', 'pda', 'version', 'langOptions'])
  },
  methods: {
    ...mapActions(['setPda', 'setUser', 'setVersion', 'setInformation', 'setLangOptions']),
    checkPda() {
      // 检查是否为pda
      const width = window.screen.availWidth
      const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)
      const pdaInfo = {
        status: width <= pdaScreenWidth || mobileUA
      }
      this.pdainfo = pdaInfo
      this.setPda(pdaInfo)
    },
    async getUserInfo() {
      // 获取用户信息
      const res = await this.$request('get', userInfo, {})
      if (res) {
        this.userinfo = res || {}
        this.setUser(res)
      }
    },
    getVersion() {
      // 获取系统版本号
      return this.$request('get', version, {})
      .then(res => {
        if (res) {
          this.versionInfo = res || {}
          this.setVersion(res)
        }
      })
    },
    async getCopyright() {
      // 获取系统信息
      const res = await this.$request('get', copyright, {})
      if (res) {
        this.setInformation(res)
        // window.document.title = res.system_name
      }
    },
    async getDicts() {
      // 获取字典
      const res = await this.$utils.getDict([370, 371, 402, 461])
      if (res) {
        const pageDict = (res[370] || []).map(i => i.value).sort((a, b) => a - b)
        if (pageDict && pageDict.length > 0) {
          localStorage.setItem(localPageKey, JSON.stringify(pageDict))
        }

        const pageSize = res[371] ? res[371][0]['value'] : null
        if (pageSize) {
          localStorage.setItem(localPageSizeKey, pageSize)
        }

        const weightConfig = res[402] ? res[402][0] : ''
        if (weightConfig) {
          const weight = weightConfig['name']
          window.document.documentElement.style.fontWeight = weight
        }

        const tableColorConfig = res[461] ? res[461][0] : ''
        if (tableColorConfig) {
          const color = tableColorConfig['name']
          this.$el.style.setProperty('--tableColor', color) 
        }
      }
    },
    checkBrowser() {
      // 检查浏览器版本s
      const qualify = this.$utils.checkBrowser()
      const { sys_config } = this.versionInfo
      
      if (!qualify && !this.pdainfo.status && !sys_config[444]) {
        this.$message({
          message: '推荐您使用Chrome 90以上版本的浏览器运行系统',
          showClose: true,
          duration: 0
        })
      }
    },
    expirePop() {
      // 无菌库过期包提醒
      const number = localStorage.getItem(departmentSterilityLibraryExpire)
      if (number > 0 && this.$route.path !== '/login') {
        this.$confirm(
          "无菌库有" + number + "件包过期，是否立刻处理？?",
          "提示",
          {
            confirmButtonText: "马上处理",
            cancelButtonText: "稍后再说",
            type: "warning",
          }
        )
          .then(() => {
            this.$router.push(`/departmentdocking/warehouse/index`);
          })
          .catch(() => {
            console.log("取消");
          });
        
        setTimeout(() => {
          this.$msgbox.close();
          localStorage.removeItem(departmentSterilityLibraryExpire)
        }, 3000)

      }
    },
    getConfigLang() {
      // 获取配置语言
      const token = this.$cookie.get(userTokenKey)
      
      if (!Object.keys(this.versionInfo).length || (token && !Object.keys(this.userinfo).length)) {
        setTimeout(() => {
          this.getConfigLang()
        }, 200)
      } else {
        this.setLangBySetting()
        this.extractLangOptions()
        // window.document.title = this.$t('local.all.systemName')
      }
    },
    setLangBySetting() {
      // 根据设定（用户信息 > 本地存储 > 全局默认）设置设定系统语言（前端和接口）
      // 根据是否是二级路径（VUE_APP_BASE）来决定是当前域名刷新还是跳转当前指定的环境
      const { VUE_APP_BASE } = process.env
      const localLang = localStorage.getItem(apiLangKey)
      const { locale: userLocale } = this.userinfo
      const { locale: versionLocale } = this.versionInfo
      const locale = userLocale || localLang || versionLocale
      const matchedLang = langs.filter(i => locale === i.apiKey)[0]
      const selectedLang = matchedLang ? matchedLang['localKey'] : 'zh-s'
      this.configLang = selectedLang
      const selectedApiKey = matchedLang ? matchedLang['apiKey'] : 'zh_CN'
      localStorage.setItem(apiLangKey, selectedApiKey)
      if (localStorage.getItem(langKey) !== this.configLang) {
        localStorage.setItem(langKey, this.configLang)

        if (!VUE_APP_BASE) {
          window.location.reload()
        }
      }

      if (VUE_APP_BASE && VUE_APP_BASE != selectedApiKey) {
        const url = `${window.location.origin}/${selectedApiKey}${this.$route.fullPath}`

        window.location.href = url
      }
    },
    extractLangOptions() {
      // 提取可选语言选项（全局语言设定 + en）
      const { locale_array } = this.versionInfo
      const langsOpts = langs.filter(i => (locale_array || []).includes(i.apiKey))

      this.setLangOptions(langsOpts)
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}

.el-table__row {
  color: var(--tableColor);
}
</style>
